import { Controller } from '@hotwired/stimulus'

export default class extends Controller {
  static targets = ['feedback']
  static values = {
    minWord: Number,
    maxWord: Number,
    text: String,
    translations: Object
  }

  connect() {
    requestAnimationFrame(() => {
      const wordCount = this.calculateWordCount(this.textValue)
      this.handleUpdate(wordCount, false)
    })
  }

  textValueChanged(text, oldText) {
    const initialUpdate = !oldText
    if (text) {
      const wordCount = this.calculateWordCount(text)
      // we don't display the feedback on the initial update
      this.handleUpdate(wordCount, !initialUpdate)
    }
  }

  calculateWordCount(text) {
    return (text.match(/([A-zÀ-ú]+){2,}/gu) || []).length
  }

  progressMapping(wordCount) {
    const percentage = (wordCount / this.minWordValue) * 100
    if (percentage < 50) {
      return 'unstarted'
    } else if (percentage >= 50 && percentage < 100) {
      return 'weak'
    } else if (percentage >= 100 && percentage < 200) {
      return 'medium'
    } else {
      return 'strong'
    }
  }

  handleUpdate(wordCount, feedback = true) {
    const progressClass = this.progressMapping(wordCount)
    if (this.element.classList.contains(progressClass)) return

    this.element.classList.remove('unstarted', 'weak', 'medium', 'strong')
    this.element.classList.add(progressClass)

    if (feedback) {
      this.feedbackTarget.classList.remove('opacity-0')
      this.feedbackTarget.innerText = this.randomFeedbackTextFor(progressClass)
    }

    this.resetTimeout()
  }

  randomFeedbackTextFor(progressClass) {
    return this.translationsValue[progressClass][
      Math.floor(Math.random() * this.translationsValue[progressClass].length)
    ]
  }

  resetTimeout() {
    if (this.timeout) {
      clearTimeout(this.timeout)
    }

    this.timeout = setTimeout(() => {
      this.feedbackTarget.classList.add('opacity-0')
    }, 4000)
  }
}
